"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _default = function _default(ResultsComponent) {
  return (0, _createReactClass.default)({
    propTypes: {
      portalId: _propTypes.default.number.isRequired,
      search: _propTypes.default.string.isRequired,
      offset: _propTypes.default.number.isRequired,
      length: _propTypes.default.number.isRequired,
      results: _propTypes.default.array.isRequired,
      onCancel: _propTypes.default.func.isRequired,
      onSelect: _propTypes.default.func.isRequired,
      forceClose: _propTypes.default.func.isRequired,
      toggleForcedOverlayFocus: _propTypes.default.func.isRequired,
      addKeyCommandListener: _propTypes.default.func.isRequired,
      removeKeyCommandListener: _propTypes.default.func.isRequired
    },
    getInitialState: function getInitialState() {
      return {
        selection: 0
      };
    },
    componentDidMount: function componentDidMount() {
      this.props.addKeyCommandListener(this.handleKeyCommand);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.props.removeKeyCommandListener(this.handleKeyCommand);
    },
    handleKeyCommand: function handleKeyCommand(editorState, command, keyboardEvent) {
      var _this$props = this.props,
          offset = _this$props.offset,
          onSelect = _this$props.onSelect,
          length = _this$props.length,
          results = _this$props.results;
      var selection = this.state.selection;
      var option = selection < results.length ? results[selection] : null;

      switch (command) {
        case 'return':
        case 'tab':
          keyboardEvent.preventDefault();
          keyboardEvent.stopPropagation();

          if (option !== null) {
            onSelect(option, {
              offset: offset,
              length: length
            });
            this.props.removeKeyCommandListener(this.handleKeyCommand);
            return true;
          }

          return null;

        case 'up-arrow':
          keyboardEvent.preventDefault();
          this.arrowUp();
          return true;

        case 'down-arrow':
          keyboardEvent.preventDefault();
          this.arrowDown();
          return true;

        case 'escape':
          {
            this.props.forceClose();
            return true;
          }

        default:
          return null;
      }
    },
    arrowUp: function arrowUp() {
      var selection = this.state.selection;

      if (selection > 0) {
        this.setState({
          selection: selection - 1
        });
      }
    },
    arrowDown: function arrowDown() {
      var results = this.props.results;
      var selection = this.state.selection;

      if (results.length > selection + 1) {
        this.setState({
          selection: selection + 1
        });
      }
    },
    render: function render() {
      var selection = this.state.selection;
      var _this$props2 = this.props,
          portalId = _this$props2.portalId,
          results = _this$props2.results,
          onSelect = _this$props2.onSelect,
          onCancel = _this$props2.onCancel,
          search = _this$props2.search,
          offset = _this$props2.offset,
          length = _this$props2.length,
          toggleForcedOverlayFocus = _this$props2.toggleForcedOverlayFocus,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["portalId", "results", "onSelect", "onCancel", "search", "offset", "length", "toggleForcedOverlayFocus"]);
      return _react.default.createElement(ResultsComponent, Object.assign({
        portalId: portalId,
        results: results,
        onSelect: onSelect,
        onCancel: onCancel,
        selection: selection,
        search: search,
        offset: offset,
        length: length,
        toggleForcedOverlayFocus: toggleForcedOverlayFocus
      }, rest));
    }
  });
};

exports.default = _default;
module.exports = exports.default;